var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
function toError(error) {
    if (error instanceof Error)
        return error;
    if (typeof error === "string")
        return new Error(error);
    try {
        return new Error(JSON.stringify(error));
    }
    catch (_a) {
        return new Error("Unknown render error");
    }
}
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.reset = function () {
            _this.setState({ hasError: false, error: undefined });
        };
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: toError(error) };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError && this.state.error) {
            if (this.props.renderFallback) {
                return this.props.renderFallback({
                    error: this.state.error,
                    reset: this.reset,
                });
            }
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsxs("div", __assign({ style: {
                    padding: "20px",
                    textAlign: "center",
                    border: "1px solid #ff4d4f",
                    borderRadius: "6px",
                    backgroundColor: "#fff2f0",
                    margin: "20px",
                } }, { children: [_jsx("h2", __assign({ style: { color: "#ff4d4f", marginBottom: "16px" } }, { children: "\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898" })), _jsx("p", __assign({ style: { color: "#666", marginBottom: "16px" } }, { children: this.state.error.message || "应用程序遇到了一个错误" })), _jsx("button", __assign({ type: "button", onClick: this.reset, style: {
                            padding: "8px 16px",
                            backgroundColor: "#1890ff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        } }, { children: "\u91CD\u8BD5" }))] })));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));
export default ErrorBoundary;
